import { SortModes } from "../../../constants/types";
import { NotificationBar, PopupStates, StoreApi, UIState } from "../types";

export const setUIState = (uiState: Partial<UIState>) => ({ setState, getState }: StoreApi) => {
    setState({
        ui: {
            ...getState().ui,
            ...uiState,
        },
    });
};

export const setNotificationBarState = (notificationBarState: Partial<NotificationBar>) => ({
    getState,
    dispatch,
}: StoreApi) => {
    dispatch(
        setUIState({
            notificationBar: {
                ...getState().ui.notificationBar,
                ...notificationBarState,
            },
        }),
    );
};

export const closeNotificationBar = () => ({ dispatch }: StoreApi) => {
    sessionStorage.setItem('hasUserClosed', 'true');
    dispatch(setNotificationBarState({ hasUserClosed: true }));
};

export const setSortMode = (sortMode: SortModes) => ({ dispatch }: StoreApi) => {
    dispatch(setUIState({ sortMode }));
};

export const setLocationAccessDenied = () => ({ dispatch }: StoreApi) => {
    dispatch(setUIState({ locationAccessDenied: true }));
};

export const setFreeServiceVisibility = (display: boolean) => ({ dispatch }: StoreApi) => {
    dispatch(setUIState({ showingFreeServices: display }));
};

export const setAssetmentFilterVisibility = (display: boolean) => ({ dispatch }: StoreApi) => {
    dispatch(setUIState({ showingAssetmentFilter: display }));
};

export const openOutsideAuPopup = () => ({ dispatch, getState }: StoreApi) => {
    if (getState().ui.outsideAuPopup === PopupStates.PENDING) {
        dispatch(setUIState({ outsideAuPopup: PopupStates.OPENED }));
    }
};

export const closeOutsideAuPopup = () => ({ dispatch, getState }: StoreApi) => {
    if (getState().ui.outsideAuPopup === PopupStates.OPENED) {
        dispatch(setUIState({ outsideAuPopup: PopupStates.CLOSED }));
    }
};

export const openLegacyBrowserPopup = () => ({ dispatch, getState }: StoreApi) => {
    if (getState().ui.legacyBrowserPopup === PopupStates.PENDING) {
        dispatch(setUIState({ legacyBrowserPopup: PopupStates.OPENED }));
    }
};

export const closeLegacyBrowserPopup = () => ({ dispatch, getState }: StoreApi) => {
    if (getState().ui.legacyBrowserPopup === PopupStates.OPENED) {
        dispatch(setUIState({ legacyBrowserPopup: PopupStates.CLOSED }));
    }
};
